import api from './api';

export interface SetupNodeSession {
  id: number;
  setup_node: number;
  session: number;
  session_name: string;
  order: number;
}

export interface SetupNode {
  id: number;
  setup: number;
  parent: number | null;
  node_type: 'question' | 'leaf';
  text: string;
  order: number;
  children?: SetupNode[];
  node_sessions?: SetupNodeSession[];
}

export interface Setup {
  id: number;
  name: string;
  is_public: boolean;
  is_deleted: boolean;
  is_modified: boolean;
  created_by: number | null;
  created_by_name?: string;
  original_author: number | null;
  original_author_name?: string;
  tags: string[];
  nodes: SetupNode[];
  created_at: string;
  updated_at: string;
}

const setupService = {
  // Get all setups (for admin)
  async getAll(): Promise<Setup[]> {
    const response = await api.get('/setups/');
    return response.data;
  },

  // Get public/default setups
  async getAvailable(): Promise<Setup[]> {
    const response = await api.get('/setups/available/');
    return response.data;
  },

  // Get single setup
  async get(id: number): Promise<Setup> {
    const response = await api.get(`/setups/${id}/`);
    return response.data;
  },

  // Create setup
  async create(data: { name: string; is_public?: boolean }): Promise<Setup> {
    const response = await api.post('/setups/', data);
    return response.data;
  },

  // Update setup
  async update(id: number, data: Partial<Setup>): Promise<Setup> {
    const response = await api.put(`/setups/${id}/`, data);
    return response.data;
  },

  // Delete setup
  async delete(id: number): Promise<void> {
    await api.delete(`/setups/${id}/`);
  },

  // Create node
  async createNode(setupId: number, data: {
    parent?: number | null;
    node_type: 'question' | 'leaf';
    text: string;
    order?: number;
  }): Promise<SetupNode> {
    const response = await api.post(`/setups/${setupId}/nodes/create/`, data);
    return response.data;
  },

  // Update node
  async updateNode(setupId: number, nodeId: number, data: {
    text?: string;
    node_type?: 'question' | 'leaf';
    order?: number;
  }): Promise<SetupNode> {
    const response = await api.put(`/setups/${setupId}/nodes/${nodeId}/`, data);
    return response.data;
  },

  // Delete node
  async deleteNode(setupId: number, nodeId: number): Promise<void> {
    await api.delete(`/setups/${setupId}/nodes/${nodeId}/`);
  },
};

export default setupService;
